<template>
  <v-container fluid>
    <v-card elevation="2">
      <v-card-title class="d-flex flex-wrap justify-space-between align-center">
        <div>
          <v-icon left>mdi-file-document-outline</v-icon>

          Detalle de Documento de Inscripción
        </div>

        <div>
          <v-btn
            class="mx-1"
            color="primary"
            title="Ir a la lista de documentos de inscripciones"
            small
            text
            @click="
              $router.push({
                name: 'documentos-inscripciones',
              })
            ">
            <v-icon left>mdi-arrow-left-bold</v-icon>

            Volver a la lista
          </v-btn>

          <v-btn
            class="mx-1"
            color="primary"
            :title="`Anterior (ID: ${navegacion.idAnterior})`"
            small
            text
            :disabled="!navegacion.idAnterior"
            @click="
              $router.push({
                name: 'documentos-inscripciones-ver',
                params: { id: navegacion.idAnterior },
              })
            ">
            <v-icon left>mdi-arrow-left</v-icon>

            Anterior
          </v-btn>

          <v-btn
            class="mx-1"
            color="primary"
            :title="`Siguiente (ID: ${navegacion.idSiguiente})`"
            small
            text
            :disabled="!navegacion.idSiguiente"
            @click="
              $router.push({
                name: 'documentos-inscripciones-ver',
                params: { id: navegacion.idSiguiente },
              })
            ">
            Siguiente

            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text v-if="cargando" class="text-center py-12">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>

        <p class="mt-4 text-h6">Cargando información...</p>
      </v-card-text>

      <v-card-text v-else-if="datos" class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <v-alert v-if="datos.eliminadoEn" type="error">
              <div class="d-flex flex-wrap justify-space-between align-center">
                Este documento fue reemplazado por otro el {{ formatFecha(datos.eliminadoEn) }}

                <v-btn
                  color="primary"
                  class="ma-1"
                  small
                  @click="
                    $router.push({
                      name: 'documentos-inscripciones-ver',
                      params: { id: datos.reemplazoId },
                    })
                  ">
                  Ver documento reemplazo
                </v-btn>
              </div>
            </v-alert>
          </v-col>

          <v-col cols="12" md="12" lg="6">
            <v-row>
              <v-col
                v-if="datos.documentoPersona.datos && datos.documentoPersona.datos.length > 0"
                cols="12"
                md="12"
                lg="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold primary--text">
                    <v-icon small color="primary">mdi-information-outline</v-icon>
                    Datos Adicionales del Documento
                  </v-card-subtitle>

                  <v-card-text>
                    <v-list dense>
                      <v-list-item v-for="dato in datos.documentoPersona.datos" :key="dato.id">
                        <v-list-item-content>
                          <v-list-item-subtitle>{{ dato.nombre }}</v-list-item-subtitle>

                          <v-list-item-title class="text-wrap">{{ dato.valor }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6" lg="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold primary--text">
                    <v-icon small color="primary">mdi-account</v-icon>

                    Información del Estudiante
                  </v-card-subtitle>

                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Nombre Completo</v-list-item-subtitle>
                          <v-list-item-title>
                            {{ nombreCompletoEstudiante }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Documento de Identidad</v-list-item-subtitle>
                          <v-list-item-title>{{ datos.inscripcion.estudiante.numeroDocumento }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>ID Estudiante</v-list-item-subtitle>
                          <v-list-item-title>{{ datos.inscripcion.estudiante.id }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6" lg="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold primary--text">
                    <v-icon small color="primary">mdi-school</v-icon>

                    Información del Programa
                  </v-card-subtitle>

                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Programa</v-list-item-subtitle>
                          <v-list-item-title class="text-wrap">
                            {{ datos.inscripcion.programa.nombreCompuesto }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Código</v-list-item-subtitle>
                          <v-list-item-title>{{ datos.inscripcion.programa.codigo }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Sede</v-list-item-subtitle>
                          <v-list-item-title>{{ datos.inscripcion.programa.sede.nombre }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Categoría</v-list-item-subtitle>
                          <v-list-item-title>{{
                            datos.inscripcion.programa.postgrado.categoria.nombre
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="12" lg="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold primary--text">
                    <v-icon small color="primary">mdi-file-check</v-icon>

                    Información del Documento
                  </v-card-subtitle>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6" lg="6" xl="6">
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Tipo de Documento</v-list-item-subtitle>
                              <v-list-item-title class="text-wrap">
                                {{ datos.documentoPersona.tipoDocumentoPersona.nombre }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Fecha de Vencimiento</v-list-item-subtitle>
                              <v-list-item-title
                                v-if="datos.documentoPersona.tipoDocumentoPersona.aplicaFechaVencimiento">
                                {{
                                  datos.documentoPersona.esIndefinido
                                    ? 'Indefinido'
                                    : datos.documentoPersona.fechaVencimiento
                                }}
                              </v-list-item-title>

                              <v-list-item-title v-else> No Aplica </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Propósito</v-list-item-subtitle>
                              <v-list-item-title>{{
                                datos.documentoPersona.tipoDocumentoPersona.proposito
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Subido Por</v-list-item-subtitle>
                              <v-list-item-title>{{ datos.documentoPersona.subidoPor }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Fecha de Creación</v-list-item-subtitle>
                              <v-list-item-title>{{ formatFecha(datos.documentoPersona.creadoEn) }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>

                      <v-col
                        v-if="datos.documentoPersona.tipoDocumentoPersona.requiereValidacion"
                        cols="12"
                        md="6"
                        lg="6"
                        xl="6">
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Estado de Revisión</v-list-item-subtitle>

                              <v-chip :color="getEstadoRevisionColor(datos.documentoPersona.estadoRevision)" small dark>
                                {{ datos.documentoPersona.estadoRevision }}
                              </v-chip>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="datos.documentoPersona.archivoRespaldoId">
                            <v-list-item-content>
                              <v-list-item-subtitle>Archivo de Respaldo</v-list-item-subtitle>

                              <v-btn
                                v-if="datos.documentoPersona.archivoRespaldoId"
                                color="primary"
                                outlined
                                small
                                title="Ver respaldo adjunto"
                                @click="verRespaldoGuardado">
                                <v-icon small>mdi-eye</v-icon>

                                Ver Respaldo
                              </v-btn>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Revisado Por</v-list-item-subtitle>

                              <v-list-item-title>{{ datos.documentoPersona.revisadoPor || 'N/A' }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Revisado En</v-list-item-subtitle>

                              <v-list-item-title>
                                {{
                                  datos.documentoPersona.fechaHoraRevision
                                    ? formatFecha(datos.documentoPersona.fechaHoraRevision)
                                    : 'N/A'
                                }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-subtitle>Observaciones</v-list-item-subtitle>

                              <v-list-item-title class="text-wrap">
                                {{ datos.documentoPersona.observaciones || 'N/A' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>

                      <v-col
                        cols="12"
                        v-if="
                          permisosDNA &&
                          datos.documentoPersona.estadoRevision === estadosTipoDocumentoPersona.PENDIENTE &&
                          datos.documentoPersona.tipoDocumentoPersona.requiereValidacion
                        ">
                        <v-divider class="mt-0"></v-divider>

                        <v-form
                          ref="formulario"
                          v-model="formularioValido"
                          class="text-center mx-auto"
                          style="max-width: 500px">
                          <v-select
                            v-model="formulario.estadoRevision"
                            :items="estadosRevision"
                            label="Estado de Revisión"
                            :rules="[rules.required]"
                            outlined
                            dense></v-select>

                          <v-textarea
                            v-model="formulario.observaciones"
                            label="Observaciones"
                            :rules="observacionesRules"
                            :counter="500"
                            maxlength="500"
                            outlined
                            rows="2"></v-textarea>

                          <div class="d-flex justify-center align-start">
                            <v-file-input
                              v-model="archivoAdjunto"
                              label="Respaldo (PDF o imagen)"
                              accept="application/pdf,image/*"
                              prepend-icon=""
                              prepend-inner-icon="mdi-paperclip"
                              :rules="archivoAdjuntoRules"
                              outlined
                              dense
                              clearable
                              show-size
                              @change="onCambioArchivo"></v-file-input>

                            <v-btn
                              class="my-1 ml-2"
                              color="primary"
                              title="Ver respaldo adjunto"
                              outlined
                              icon
                              :disabled="!previsualizacion"
                              @click="verRespaldo">
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </div>

                          <v-btn
                            color="primary"
                            outlined
                            :disabled="!formularioValido"
                            @click="mostradoDialogoConfirmacion = true">
                            <v-icon left>mdi-content-save</v-icon>

                            Guardar Revisión
                          </v-btn>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="12" lg="6" class="col-preview-documento">
            <v-card outlined>
              <v-card-subtitle class="font-weight-bold primary--text">
                <v-icon small color="primary">mdi-file-eye</v-icon>
                Vista Previa del Documento
              </v-card-subtitle>

              <v-card-text>
                <div class="d-flex flex-wrap justify-space-between align-center">
                  <template v-if="datos.documentoPersona?.archivo">
                    <v-btn small color="primary" @click="descargarDocumento" class="ml-2">
                      <v-icon small left>mdi-download</v-icon>
                      Descargar
                    </v-btn>

                    <div class="text-center mb-2">
                      <v-chip small>
                        <v-icon small left>mdi-file-pdf-box</v-icon>
                        {{ datos.documentoPersona.archivo.extencion.toUpperCase() }}
                      </v-chip>
                      <v-chip small class="ml-2">
                        {{ formatBytes(datos.documentoPersona.archivo.size) }}
                      </v-chip>
                    </div>
                  </template>

                  <v-alert v-else class="mt-5" border="left" colored-border type="warning" text>
                    No hay archivo disponible para este registro. Es posible que el archivo haya sido eliminado o que no
                    se haya subido correctamente.
                  </v-alert>
                </div>

                <iframe
                  v-if="pdfUrl"
                  :src="pdfUrl"
                  width="100%"
                  height="800px"
                  style="border: 1px solid #ddd; border-radius: 4px"></iframe>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-else class="text-center py-12">
        <v-icon size="64" color="error">mdi-alert-circle-outline</v-icon>

        <p class="mt-4 text-h6">No se pudo cargar la información</p>
      </v-card-text>
    </v-card>

    <notifications group="notifications" position="top right" />

    <ConfirmacionAccion
      v-model="mostradoDialogoConfirmacion"
      v-bind="confirmacion"
      @aceptar="() => confirmacion.aceptar()" />

    <v-dialog v-model="dialogoRespaldo" max-width="600px">
      <v-card>
        <v-card-title class="primary--text">
          <span> Vista Previa del Respaldo </span>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogoRespaldo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <ImagenPreview v-if="esImagen" :src="previsualizacion" nombre-archivo="Respaldo" />
          <PdfPreview v-else-if="esPDF" :src="previsualizacion" nombre-archivo="Respaldo" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import documentosPersonasService from '../../comisiones/services/documentos-personas.service';
import inscripcionesDocumentosPersonasService from '../../comisiones/services/inscripciones-documentos-personas.service';
import { ESTADOS_REVISIONES_ARRAY, ESTADOS_TIPO_DOCUMENTO_PERSONA } from '../../comisiones/utils/constantes';
import { concatenar } from '../../pagos/utils/funciones';
import ConfirmacionAccion from '../../documentacion/components/ConfirmacionAccion.vue';
import { mapGetters } from 'vuex';
import ImagenPreview from '../../documentacion/components/ImagenPreview.vue';
import PdfPreview from '../../documentacion/components/PdfPreview.vue';

export default {
  name: 'DocumentosInscripcionesVer',
  components: {
    ConfirmacionAccion,
    ImagenPreview,
    PdfPreview,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      datos: null,
      cargando: true,
      pdfUrl: null,
      navegacion: {
        idAnterior: null,
        idSiguiente: null,
      },
      formulario: {
        estadoRevision: null,
        observaciones: null,
        archivoBase64: null,
      },
      formularioValido: false,
      estadosRevision: ESTADOS_REVISIONES_ARRAY,
      estadosTipoDocumentoPersona: ESTADOS_TIPO_DOCUMENTO_PERSONA,
      rules: {
        required: (v) => !!v || 'Este campo es requerido',
      },
      mostradoDialogoConfirmacion: false,
      confirmacion: {
        titulo: 'Confirmar Revisión',
        mensaje: '¿Está seguro de guardar la revisión del documento?',
        textoAceptar: 'Sí, guardar',
        textoCancelar: 'Cancelar',
        realizandoAccion: false,
        aceptar: () => {
          this.guardar();
        },
      },
      archivoAdjunto: null,
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
      archivoAdjuntoRules: [
        (v) => !v || v.size <= 10 * 1024 * 1024 || 'El archivo debe ser menor a 10MB',
        (v) =>
          !v ||
          ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'].includes(v.type) ||
          'Solo se permiten archivos PDF o imágenes (JPEG, PNG, GIF)',
      ],
      dialogoRespaldo: false,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.cargarDatos();
        this.$refs.formulario?.reset();
        this.$refs.formulario?.resetValidation();
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
      },
    },
  },
  computed: {
    nombreCompletoEstudiante() {
      if (!this.datos || !this.datos.inscripcion || !this.datos.inscripcion.estudiante) {
        return '';
      }

      return concatenar(
        this.datos.inscripcion.estudiante.nombres,
        this.datos.inscripcion.estudiante.primerApellido,
        this.datos.inscripcion.estudiante.segundoApellido,
      );
    },
    observacionesRules() {
      const rules = [(v) => !v || v.length <= 500 || 'Máximo 500 caracteres'];

      if (this.formulario.estadoRevision === ESTADOS_TIPO_DOCUMENTO_PERSONA.RECHAZADO) {
        rules.unshift((v) => !!v || 'Las observaciones son obligatorias cuando se rechaza');
      }

      return rules;
    },
    ...mapGetters({
      permisosDNA: 'comision/permisosDNA',
    }),
  },
  methods: {
    async cargarDatos() {
      try {
        this.cargando = true;
        const response = await inscripcionesDocumentosPersonasService.findOne(this.id);
        const data = response.data;

        this.datos = data.datos;
        this.navegacion.idAnterior = data?.navegacion?.idAnterior || null;
        this.navegacion.idSiguiente = data?.navegacion?.idSiguiente || null;
        this.cargarPDF();
      } catch (error) {
        window.console.error('Error al cargar datos:', error);
      } finally {
        this.cargando = false;
      }
    },
    cargarPDF() {
      if (this.datos && this.datos.documentoPersona?.archivo) {
        const base64 = this.datos.documentoPersona.archivo.file64;
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/pdf' });

        this.pdfUrl = URL.createObjectURL(blob);
      }
    },
    descargarDocumento() {
      if (this.pdfUrl) {
        const link = document.createElement('a');
        link.href = this.pdfUrl;
        link.download = `documento_${this.datos.documentoPersona.id}.pdf`;
        link.click();
      }
    },
    formatFecha(fecha) {
      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    getEstadoRevisionColor(estado) {
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
    async guardar() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      this.confirmacion.realizandoAccion = true;

      try {
        const response = await documentosPersonasService.revisar(this.datos.documentoPersona.id, this.formulario);
        const data = response.data;
        const mensaje = data.mensaje || 'Documento revisado correctamente';

        this.$notify({
          group: 'notifications',
          title: 'Documento revisado',
          text: mensaje,
          type: 'success',
        });
        this.mostradoDialogoConfirmacion = false;
        this.$refs.formulario.reset();
        this.$refs.formulario.resetValidation();
        this.cargarDatos();
      } catch (err) {
        const response = err?.response;
        const data = response?.data;
        const errores = data?.errores || 'Error al revisar el documento';

        window.console.error('Error al revisar documento:', err);

        const mensajesErrores = Object.values(errores).flat().join(', ');

        this.$notify({
          group: 'notifications',
          title: 'Error al revisar documento',
          text: mensajesErrores,
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    onCambioArchivo(archivo) {
      this.previsualizacion = null;
      this.esImagen = false;
      this.esPDF = false;
      this.formulario.archivoBase64 = null;

      if (!archivo) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target.result;
        const blob = new Blob([archivo], { type: archivo.type });

        this.formulario.archivoBase64 = result.split(',')[1];
        this.previsualizacion = URL.createObjectURL(blob);

        if (archivo.type.startsWith('image/')) {
          this.esImagen = true;
        } else if (archivo.type === 'application/pdf') {
          this.esPDF = true;
        }
      };

      reader.readAsDataURL(archivo);
    },
    verRespaldo() {
      this.dialogoRespaldo = true;
    },
    verRespaldoGuardado() {
      const respaldo = this.datos?.documentoPersona?.archivoRespaldo;

      if (!respaldo?.file64) return;

      try {
        const byteCharacters = atob(respaldo.file64);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: respaldo.mimetype });

        this.previsualizacion = URL.createObjectURL(blob);
        this.esImagen = respaldo.mimetype.startsWith('image/');
        this.esPDF = respaldo.mimetype === 'application/pdf';
        this.dialogoRespaldo = true;
      } catch (error) {
        window.console.error('Error al cargar respaldo guardado:', error);
      }
    },
  },
};
</script>

<style scoped>
.text-wrap {
  white-space: normal;
  word-wrap: break-word;
}

@media (min-width: 1264px) {
  .col-preview-documento {
    position: sticky;
    top: 12px;
    align-self: flex-start;
  }
}
</style>